/** ES2022 `.at(-1)` without relying on prototype (old WebView / wallet DApp). */
export function lastAt<T>(items: readonly T[] | undefined | null): T | undefined {
	if (items == null || items.length === 0) return undefined;
	return items[items.length - 1];
}
